var map = {
	"./g1.jpg": 522,
	"./g2.jpg": 325,
	"./g3.jpg": 584,
	"./g4.jpg": 747,
	"./g5.jpg": 982,
	"./g6.jpg": 121,
	"./g7.jpg": 172,
	"./g8.jpg": 327
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 275;